module.exports = __webpack_public_path__ + "img/product17.e5dba1f2.jpg";